<template>
  <v-dialog v-model="dialog" scrollable persistent>
    <v-card class="cardStyle">
      <v-card-text style="padding: 15px">
        <v-container fluid style="height: 100%">
          <v-row align="center" justify="center" style="height: 100%">
            <v-col cols="12" sm="10" md="8" lg="6" xl="4" style="height: 100%">
              <v-img style="height: 100%" src="/Splash.png" contain />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <div style="align-items: center;display: flex">
          <v-checkbox
            v-if="$user"
            v-model="dontShowAgain"
            label="Don't show more"
          />
          <v-btn
            class="btnYes"
            text
            @click="saveDecision()"
          >
            {{ $t('OK') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";

export default {
    name: 'SplashScreen',
    data: () => ({
        dialog: false,
        dontShowAgain: false
    }),
    created () {
        this.$root.$on('show-splash-check', (cif) => {
            if (cif) {
                this.checkSplash(cif);
            }
        });
    },
    methods: {
        checkSplash (cif = null) {
            let decision;
            let cifSplash = "";
            if (cif) {
                cifSplash = cif;
            }
            if (this.$user && this.$user.cif) {
                cifSplash = this.$user.cif;
            }
            ApiRepository.getDecisionUser(cifSplash)
                .then((res) => {
                    decision = res.data.decision;
                    const user = res.data.user;
                    if (decision && user.cif) {
                        this.dialog = true;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        saveDecision () {
            const dec = !this.dontShowAgain;
            ApiRepository.updateDecision(this.$user.email, dec)
                .then(() => {
                    this.dialog = false;
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }
};
</script>
